import { render, staticRenderFns } from "./codeedit.vue?vue&type=template&id=0cc4d380&"
import script from "./codeedit.vue?vue&type=script&lang=js&"
export * from "./codeedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports